import { render, staticRenderFns } from "./FirstBlock.vue?vue&type=template&id=d00cad4c&"
import script from "./FirstBlock.vue?vue&type=script&lang=ts&"
export * from "./FirstBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports